export default __webpack_public_path__ + "assets/images/c29463bfdf71d435d08fcf9225ec27bf.jpg";